
/**
 * Utility functions for handling categories and slugs throughout the application
 */

/**
 * Creates a slug from a category name by converting to lowercase,
 * removing special characters, and replacing spaces with hyphens
 */
export const createSlug = (name: string): string => {
  return name.toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w-]+/g, '')        // Remove all non-word chars
    .replace(/--+/g, '-')           // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
};

/**
 * Converts a category ID to a human-readable name using a predefined mapping
 */
export const getCategoryName = (id: string): string => {
  // Map of known category IDs to names
  const categoryMap: {[key: string]: string} = {
    "1": "Fantasy",
    "2": "Science Fiction",
    "3": "Romance",
    "4": "Mystery",
    "5": "Horror",
    "6": "Thriller",
    "7": "Historical Fiction",
    "8": "Young Adult",
    "9": "Children's",
    "10": "Non-fiction",
    "11": "Fiction",
    "12": "Sci-Fi",
    "14": "Adventure",
  };
  
  return categoryMap[id] || `Category ${id}`;
};
